import { FC } from 'react';
import { DozukiFooter } from '@dozuki/web-js/components';
import { useSiteInfo } from '~/pages/_shared';
import { Link } from '~/ui-components';
import { useLocalization } from '~/framework';
import { Box } from '@chakra-ui/react';

export const Footer: FC = () => {
   const { _js } = useLocalization();
   const { data: siteInfo } = useSiteInfo();

   const customFooterHtml = siteInfo?.['appearance-footer'];

   return (
      <>
         {customFooterHtml && (
            <Box
               aria-label="custom-footer"
               dangerouslySetInnerHTML={{
                  __html: customFooterHtml,
               }}
            />
         )}
         <DozukiFooter
            siteTitle={siteInfo?.title}
            siteDomain={siteInfo?.domain}
            footerLinks={siteInfo?.footer_links}
            LinkComponent={Link}
            _js={_js}
            version={process.env.NEXT_PUBLIC_APP_VERSION}
         />
      </>
   );
};
